const rutterClientId = process.env.REACT_APP_RUTTER_CLIENT_ID;

const rutterClienSecret = process.env.REACT_APP_RUTTER_CLIENT_SECRET;

const rutterPublicKey = process.env.REACT_APP_RUTTER_PUBLIC_KEY;

const rutterHeader = { Authorization: `Base ${btoa(`${rutterClientId}:${rutterClienSecret}`)}` };

export { rutterPublicKey, rutterHeader, rutterClientId, rutterClienSecret };
